import { Pipe, PipeTransform } from '@angular/core';
import { MaderaSeleccionada } from './models/estudiante-examen.model';

@Pipe({
  name: 'findMadera',
  pure: false
})
export class FindMaderaPipe implements PipeTransform {
  transform(maderasSeleccionadas: MaderaSeleccionada[], tipoId: number): MaderaSeleccionada | undefined {
    return maderasSeleccionadas.find(m => m.tipo.id === tipoId);
  }
}